import { useState } from "react";
import { Dropzone } from "@mantine/dropzone";
import { Text } from "@mantine/core";
import { IconUpload } from "@tabler/icons-react";

const UploadBox = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleDrop = (files) => {
    const filePreviews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setUploadedFiles(filePreviews);
  };

  return (
    <div>
      <Dropzone
        onDrop={handleDrop}
        className="w-full p-4 border border-gray-300 rounded-md"
      >
        <div className="text-center">
          <IconUpload size={40} className="mx-auto text-gray-400" />
          <Text className="mt-2 text-gray-500">Upload File</Text>
          <Text className="text-sm text-gray-400">
            Drag and Drop files Here
          </Text>
          <button className="px-4 py-2 mt-4 text-white bg-black rounded-full">
            Browse File
          </button>
        </div>
      </Dropzone>

      {uploadedFiles.length > 0 && (
        <div className="mt-4 space-y-3">
          <h4 className="font-semibold text-gray-700">Uploaded Files</h4>
          {uploadedFiles.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-4 p-2 border rounded"
            >
              {item.file.type.startsWith("image/") ? (
                <img
                  src={item.preview}
                  alt={item.file.name}
                  className="object-cover w-16 h-16 rounded"
                />
              ) : (
                <div className="flex items-center justify-center w-16 h-16 text-xs text-gray-600 bg-gray-200 rounded">
                  {item.file.name.split(".").pop().toUpperCase()}
                </div>
              )}
              <div>
                <p className="text-sm font-medium">{item.file.name}</p>
                <p className="text-xs text-gray-500">
                  {(item.file.size / 1024).toFixed(2)} KB
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UploadBox;
